const templateVariantSettings = {
  speedBump: {
    borderWithRadius: false,
  },
  header: "COMPRESSED",
  homePage: "HomeTemplateV3",
  websiteName: "Desert Valleys FCU",
  about: null,
  contactUsPage: "ContactUsTemplateV3",
  dynamicPage: "DynamicTemplateV3",
  footer: null,
};

module.exports = templateVariantSettings;
